import React from 'react';
import { Wrapper } from './NavigationDropdownItem.style';

interface DropdownItemProps {
  label: React.ReactNode;
  link: string;
  onClick?: () => void;
}

export const NavigationDropdownItem: React.FC<DropdownItemProps> = ({
  label,
  link,
  onClick,
}) => {
  return (
    <Wrapper>
      <a href={link} onClick={onClick}>
        {label}
      </a>
    </Wrapper>
  );
};
